import { render } from "./AboutDialog.vue?vue&type=template&id=060232a4&scoped=true&ts=true"
import script from "./AboutDialog.vue?vue&type=script&lang=ts"
export * from "./AboutDialog.vue?vue&type=script&lang=ts"

import "./AboutDialog.vue?vue&type=style&index=0&id=060232a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060232a4"]])

export default __exports__